function toTenantOrigin(domain: string | null | undefined): string | null {
  const trimmed = domain?.trim();
  if (!trimmed) return null;

  const withoutTrailingSlash = trimmed.replace(/\/+$/, '');
  if (/^https?:\/\//i.test(withoutTrailingSlash)) {
    return withoutTrailingSlash;
  }

  return `https://${withoutTrailingSlash}`;
}

export function isAbsoluteStorefrontHref(href: string | null | undefined): boolean {
  return Boolean(href && /^https?:\/\//i.test(href));
}

export function resolveVendorStorefrontHref(options: {
  domain?: string | null;
  vendorSlug?: string | null;
  fallbackUrl?: string | null;
}): string {
  const origin = toTenantOrigin(options.domain);
  if (origin) {
    return `${origin}/`;
  }

  const slug = options.vendorSlug?.trim();
  if (slug) {
    return `/${slug}`;
  }

  return options.fallbackUrl?.trim() || '#';
}

export function resolveProductStorefrontHref(options: {
  domain?: string | null;
  vendorSlug?: string | null;
  productId?: number | string | null;
  productSlug?: string | null;
  fallbackUrl?: string | null;
}): string {
  const { productId, productSlug } = options;
  const hasProductPath =
    productId !== null &&
    productId !== undefined &&
    productId !== '' &&
    Boolean(productSlug);

  if (!hasProductPath) {
    return options.fallbackUrl?.trim() || '#';
  }

  const origin = toTenantOrigin(options.domain);
  if (origin) {
    return `${origin}/product/${productId}/${productSlug}`;
  }

  const vendorSlug = options.vendorSlug?.trim();
  if (vendorSlug) {
    return `/${vendorSlug}/${productId}/${productSlug}`;
  }

  return options.fallbackUrl?.trim() || '#';
}
